import React from 'react';
import { Typography, Row, Col, Card } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph, Text } = Typography;

const PRICE_PER_USER = 2.99;

const PricesPage = () => {
  const { t } = useTranslation();

  const examples = [
    { users: 1, key: 'free' },
    { users: 5, key: 'small' },
    { users: 10, key: 'medium' },
    { users: 20, key: 'large' },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title>{t('prices')}</Title>

      {/* Hero pricing */}
      <Card
        style={{
          textAlign: 'center',
          marginBottom: 32,
          background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
          border: 'none',
        }}
      >
        <Text style={{ fontSize: '3em', fontWeight: 'bold', color: '#fff' }}>
          {PRICE_PER_USER.toFixed(2)} €
        </Text>
        <Paragraph style={{ fontSize: '1.2em', color: 'rgba(255,255,255,0.85)', margin: 0 }}>
          {t('perUserPerMonth')}
        </Paragraph>
        <Paragraph style={{ color: 'rgba(255,255,255,0.65)', marginBottom: 0 }}>
          {t('taxExcluded')}
        </Paragraph>
      </Card>

      {/* First user free callout */}
      <Paragraph style={{ textAlign: 'center', fontSize: '1.1em', marginBottom: 24 }}>
        {t('firstUserFree')}
      </Paragraph>

      {/* Example pricing cards */}
      <Title level={4} style={{ textAlign: 'center', marginBottom: 16 }}>
        {t('pricingExamples')}
      </Title>
      <Row gutter={[16, 16]} justify="center">
        {examples.map((example) => {
          const billableUsers = Math.max(0, example.users - 1);
          const total = billableUsers * PRICE_PER_USER;

          return (
            <Col xs={24} sm={12} md={6} key={example.key}>
              <Card
                hoverable
                style={{
                  textAlign: 'center',
                  height: '100%',
                  border: example.key === 'free' ? '2px solid #52c41a' : undefined,
                }}
              >
                <Text style={{ fontSize: '1.1em', display: 'block', marginBottom: 8 }}>
                  {example.users} {example.users === 1 ? t('user') : t('users')}
                </Text>
                <Text style={{ fontSize: '2em', fontWeight: 'bold', display: 'block' }}>
                  {total === 0 ? t('free') : `${total.toFixed(2)} €`}
                </Text>
                <Text type="secondary" style={{ display: 'block' }}>
                  {total === 0
                    ? t('noCharge')
                    : `${billableUsers} × ${PRICE_PER_USER.toFixed(2)} € / ${t('month')}`}
                </Text>
                <Text type="secondary" style={{ display: 'block', fontSize: '0.85em' }}>
                  {t('tax')}
                </Text>
              </Card>
            </Col>
          );
        })}
      </Row>

      {/* Contact for large teams */}
      <Card style={{ textAlign: 'center', marginTop: 32 }}>
        <Paragraph style={{ fontSize: '1.1em', marginBottom: 4 }}>
          {t('moreThanTwenty')}?
        </Paragraph>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          {t('contactUs')} — {t('emailSales')}
        </Paragraph>
      </Card>
    </div>
  );
};

export default PricesPage;
